import styled from "styled-components";

import { Error } from "./Error.styled";

const CheckBoxRoot = styled.div`
  ${Error} {
    margin-top: 8px;
  }
`;

export default CheckBoxRoot;
